// extracted by mini-css-extract-plugin
export default {"record":"index_record__swtRM"};